import { useEffect } from 'react';
import { useLocation } from 'react-router';
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

function Layout({ page, children }) {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <>
            <Header page={page} />

            <main className="main-content" id="main">
                {children}
            </main>

            <Footer />
        </>
    );
}

export default Layout;
